import { render, staticRenderFns } from "./ShortLink.vue?vue&type=template&id=570e7f88&scoped=true"
import script from "./ShortLink.vue?vue&type=script&lang=js"
export * from "./ShortLink.vue?vue&type=script&lang=js"
import style0 from "./ShortLink.vue?vue&type=style&index=0&id=570e7f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570e7f88",
  null
  
)

export default component.exports